export const articleSignupPrompt = {
  title: "Know if a stock is halal in seconds",
  preview: {
    halal: "Halal",
    notHalal: "Not halal",
    portfolio: "Portfolio: 100% halal",
  },
  features: {
    screener: "Halal screener",
    topHalal: "Top halal stocks",
    portfolio: "Portfolio check",
  },
  cta: "Create a free account",
  dismiss: "Keep reading",
  note: "Free · No credit card",
} as const;
